import React, { FC } from 'react';
import styles from './sidepanel.module.scss';

const SidepanelContent: FC = (props) => (
    <div className={styles.sidepanelContent}>
        {props.children}
    </div>
)

export default SidepanelContent;